import React, { ReactElement } from 'react';
import { Col, Heading, Row } from 'idsk-react-components';
import PripomienkaDetailRow from './PripomienkaDetailRow';
import PripomienkaOdoslanaTag from '../../PripomienkaOdoslanaTag';
import PripomienkaDetail from '../../../model/pripomienka/PripomienkaDetail';
import mapDate from '../../../function/mapDate';
import { useUserContext } from '../../../context/UserContext';
import './pripomienkaDetail.scss';
import UserRole from '../../../model/currentuser/UserRole';

interface Props {
  pripomienkaDetail: PripomienkaDetail;
}

const PripomienkaDetailComponent = ({
  pripomienkaDetail,
}: Props): ReactElement => {
  const { legislationProcess, pouzivatel } = useUserContext();
  if (!pripomienkaDetail) {
    return null;
  }

  const getSomPodporovatelData = (data): string => {
    if (data === true) {
      return 'áno';
    }
    if (data === false) {
      return 'nie';
    }
    return null;
  };

  const isAdminOrVyhodnocovatel = (): boolean => pouzivatel != null
      && (pouzivatel.opravnenia.includes(UserRole.SUPERADMIN)
      || pouzivatel.opravnenia.includes(UserRole.VYHODNOCOVATEL));

  return (
    <>
      <PripomienkaDetailRow
        header="Názov LP:"
        data={legislationProcess?.nazovPredpisu}
      />
      <section className="organizacia-pripomienky-section">
        <Row className="row-heading">
          <Col>
            <Heading size="m">PRIPOMIENKOVATEĽ</Heading>
          </Col>
        </Row>
        <PripomienkaDetailRow
          header="Pripomienkujúci subjekt:"
          data={pripomienkaDetail.pripomienkujuciSubjekt ? pripomienkaDetail.pripomienkujuciSubjekt.fullName : null}
        />
        {isAdminOrVyhodnocovatel() && (
          <>
            <PripomienkaDetailRow
              header="Pripomienkovateľ:"
              data={pripomienkaDetail.pripomienkovatel ? pripomienkaDetail.pripomienkovatel.fullName : null}
            />
            <PripomienkaDetailRow
              header="Email pripomienkovateľa:"
              data={pripomienkaDetail.pripomienkovatel ? pripomienkaDetail.pripomienkovatel.shortName : null}
            />
          </>
        )}
        <PripomienkaDetailRow
          header="Som podporovateľ:"
          data={getSomPodporovatelData(pripomienkaDetail.somPodporovatel)}
        />

      </section>
      <section className="udaje-pripomienky-section">
        <Row className="row-heading">
          <Col>
            <Heading size="m">ÚDAJE PRIPOMIENKY</Heading>
          </Col>
        </Row>
        <PripomienkaDetailRow header="Pripomienka k:" data={pripomienkaDetail.pripomienkaK} />
        <PripomienkaDetailRow header="Typ pripomienky:" data={pripomienkaDetail.typ} />
        <PripomienkaDetailRow
          header="Povaha pripomienky:"
          data={pripomienkaDetail.povahaPripomienky}
        />
        <PripomienkaDetailRow
          header="Dátum vytvorenia:"
          data={mapDate(pripomienkaDetail.datumPripomienkovania)}
        />
        <PripomienkaDetailRow
          header="Počet podporovateľov:"
          data={pripomienkaDetail.pocetPodporovatelov}
        />
        {pripomienkaDetail.odoslana !== null && (
          <Row className="pripomienka-detail-row">
            <Col width="one-quarter">
              <span className="information-header">Stav: </span>
            </Col>
            <Col width="three-quarters">
              <PripomienkaOdoslanaTag isOdoslana={pripomienkaDetail.odoslana} />
            </Col>
          </Row>
        )}
        <div id="pripomienka-text">
          <PripomienkaDetailRow header="Text pripomienky:" data={pripomienkaDetail.text} />
        </div>
      </section>
    </>
  );
};

export default PripomienkaDetailComponent;
